import nextI18nextConfig from '../../next-i18next.config'
import {createUrl} from './createUrl'
import {TranslatedEntry} from '../types'

type HrefLang = {
  href: string
  hrefLang: string
}

/**
 * Invalid href languages are any translations that have a custom canonical url set
 */
export const getValidHrefLanguages = (
  currentLocale: string,
  translations: TranslatedEntry[],
): HrefLang[] => {
  const {defaultLocale} = nextI18nextConfig.i18n

  return translations.reduce((accumulator, translation) => {
    const {canonicalUrl, locale, slug} = translation

    if (currentLocale !== defaultLocale && currentLocale === locale) {
      /**
       * Do not output hrefLang tags for the current locale
       */
      return accumulator
    }

    if (!canonicalUrl || slug === canonicalUrl) {
      const hrefLang = locale === defaultLocale ? 'x-default' : locale

      accumulator.push({
        href: createUrl(slug),
        hrefLang,
      })
    }

    return accumulator
  }, [])
}
